$(function() {
    setStoreSlide();
    setMoviePlay();
});

$(window).on('load resize', function() {
    imageSwitch();
});

function setStoreSlide() {
    $('#store .slide').slick({
        fade: true,
        speed: 1500,
        autoplaySpeed: 3000,
        arrows: false,
        autoplay: true,
        dots: true
    });
    imageSwitch();
};

function imageSwitch() {
    var winW = parseInt($(window).width());
    var $elem = $("#store .slide_item img");
    var sp = "_sp.";
    var pc = "_pc.";
    $elem.each(function() {
        var $this = $(this);
        if (winW <= 768) {
            $this.attr("src", $this.attr("src").replace(pc, sp));
        } else {
            $this.attr("src", $this.attr("src").replace(sp, pc));
        }
    });
}

function setMoviePlay() {
    var video = $('#movie video')[0];
    //画面クリックで再生・ポーズ
    $(".movie_thumb img").click(function() {
        $(".movie_bg").css("display", "block");
        $(".movie_close").css("display", "block");
        $("#movie").fadeIn("slow");
        video.play();
        video.currentTime = 0;
    });

    video.on('click', function() {
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    });
    video.addEventListener('ended', function() {
        video.load();
        $(".movie_bg").fadeOut("slow");
        $("#movie").fadeOut("slow");
        $(".movie_close").fadeOut("slow");
        video.autoplay = false;

    }, false);


    var ua = navigator.userAgent;
    if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
        $("video").prop('muted', true);
    } else {
        $("video").prop('muted', false);
    }
    $(window).on('load resize', function() {
        var movieHeight = $("#movie").width() * 0.5625;
        $("#movie").css('height', movieHeight + 'px');
    });
};


function movieClose() {
    video.load();
    $("#movie").fadeOut("slow");
    $(".movie_bg").fadeOut("slow");
    $(".movie_close").fadeOut("slow");
    video.autoplay = false;
}